import { cn } from "@web/lib/utils"
import SealCdLoading from "./assets/selo-valida.png"
import SealRepLoading from "./itens-de-seguranca/reparado/1.png"
import SealSubLoading from "./itens-de-seguranca/subsequente/1.png"

const sealImages: Record<string, string> = {
  "SELO REPARADO": SealRepLoading,
  "CONFORMIDADE DECLARADA": SealCdLoading,
  SUBSEQUENTE: SealSubLoading,
  Validador: SealCdLoading,
}

const sealStyles: Record<string, { wrapper?: string; image?: string; serialBox?: string }> = {
  "SELO REPARADO": {
    wrapper: "h-[130px] w-[300px]",
    serialBox: "left-[83px] top-[85px] text-white bg-black/70",
  },
  "CONFORMIDADE DECLARADA": {
    wrapper: "h-[150px] w-[300px]",
    serialBox: "left-[78px] top-[75px] text-white bg-black/70",
  },
  SUBSEQUENTE: {
    wrapper: "h-[150px] w-[300px]",
    serialBox: "left-[40px] top-[60px] text-[18px] text-white bg-black/70",
  },
  Validador: {
    wrapper: "h-[130px] sw-[300px]",
    serialBox: "left-[75px] top-[65px] text-white bg-black/70",
  },
}

export type SealMaskProps = { serial: string; className?: string; publicHash: string; productName?: string }

export function SealMask({ serial, className, productName }: SealMaskProps) {
  const background = sealImages["SUBSEQUENTE"] ?? SealCdLoading

  const styles = sealStyles["SUBSEQUENTE"] ?? {
    wrapper: "h-[150px] w-[300px]",
    serialBox: "left-[78px] top-[75px] text-white bg-black/70",
  }

  return (
    <div className={cn(styles.wrapper, className)}>
      <div
        className={cn("h-full w-full", styles.image ?? "bg-center bg-cover")}
        style={{
          backgroundImage: `url(${background})`,
          backgroundPosition: "center",
          backgroundSize: "contain",
          backgroundRepeat: "no-repeat",
        }}>
        <div className="relative h-full w-full">
          <span className={cn("absolute rounded-sm text-xl px-2", styles.serialBox)}>{serial}</span>
        </div>
      </div>
    </div>
  )
}
